/**
 * Sequences domain — entity types + non-hook helpers.
 *
 * Entity types are pure re-exports of the generated shapes. The query-key
 * helper is hand-written (not the generated `listSequencesQueryKey`) so the
 * per-campaign sequence cache keeps the same key it had before the codegen
 * migration — hand-written callers that still read/invalidate that cache
 * (`sequence_templates_api.ts`, the sequence wizard) stay coherent with the
 * generated hooks.
 */

import type { QueryKey } from '@tanstack/react-query'

export type { SequenceDetail as Sequence } from '../generated/types/SequenceDetail'
export type { SequenceStep } from '../generated/types/SequenceStep'

/**
 * Canonical cache key for "the sequence of campaign N". The list endpoint
 * returns an array of at most one sequence; `useGetCampaignSequence` unwraps it
 * to a single `Sequence | null` under this key. Every sequence mutation
 * invalidates it (see `invalidation.ts`).
 */
export const sequenceByCampaignKey = (campaignId: number): QueryKey =>
  ['sequences', 'campaign', campaignId] as const
